import apiClient from "./client";

/**
 * Users API Service
 */
export const usersApi = {
  /**
   * Get all users
   */
  getAll: () => {
    return apiClient.get("/users");
  },

  /**
   * Get user by ID
   */
  getById: (id) => {
    return apiClient.get(`/users/${id}`);
  },

  /**
   * Create a new user
   */
  create: (userData) => {
    return apiClient.post("/users", userData);
  },

  /**
   * Update a user
   */
  update: (id, userData) => {
    return apiClient.put(`/users/${id}`, userData);
  },

  /**
   * Delete a user
   */
  delete: (id) => {
    return apiClient.delete(`/users/${id}`);
  },

  /**
   * Invite a new user via email
   */
  invite: (inviteData) => {
    return apiClient.post("/users/invite", inviteData);
  },

  /**
   * Get all invitations
   */
  getInvitations: (status = null) => {
    const params = status ? { status } : {};
    return apiClient.get("/users/invitations", params);
  },

  /**
   * Get invitation by ID
   */
  getInvitation: (id) => {
    return apiClient.get(`/users/invitations/${id}`);
  },

  /**
   * Resend invitation
   */
  resendInvitation: (id) => {
    return apiClient.post(`/users/invitations/${id}/resend`);
  },

  /**
   * Revoke invitation
   */
  revokeInvitation: (id) => {
    return apiClient.post(`/users/invitations/${id}/revoke`);
  },

  /**
   * Validate invitation token (public)
   */
  validateInvitation: (token) => {
    return apiClient.get("/users/invitations/validate", { token });
  },

  /**
   * Accept invitation (public)
   */
  acceptInvitation: (token, password) => {
    return apiClient.post("/users/invitations/accept", { token, password });
  },
};

/**
 * Tenants API Service
 */
export const tenantsApi = {
  /**
   * Get all tenants (global admin only)
   */
  getAll: () => {
    return apiClient.get("/tenants");
  },

  /**
   * Get tenant by ID
   */
  getById: (id) => {
    return apiClient.get(`/tenants/${id}`);
  },

  /**
   * Get current user's tenant
   */
  getCurrent: () => {
    return apiClient.get("/tenants/current");
  },

  /**
   * Create a new tenant (global admin only)
   */
  create: (tenantData) => {
    return apiClient.post("/tenants", tenantData);
  },

  /**
   * Update a tenant
   */
  update: (id, tenantData) => {
    return apiClient.put(`/tenants/${id}`, tenantData);
  },

  /**
   * Delete a tenant (global admin only)
   */
  delete: (id, reason = null) => {
    return apiClient.delete(`/tenants/${id}`, reason ? { reason } : {});
  },

  /**
   * Mark tenant onboarding as complete
   */
  completeOnboarding: (id) => {
    return apiClient.post(`/tenants/${id}/complete-onboarding`);
  },

  /**
   * Get settings for current tenant
   */
  getCurrentSettings: () => {
    return apiClient.get("/tenants/current/settings");
  },

  /**
   * Get settings for a specific tenant (global admin)
   */
  getSettings: (id) => {
    return apiClient.get(`/tenants/${id}/settings`);
  },

  /**
   * Update settings for current tenant
   */
  updateCurrentSettings: (settings) => {
    return apiClient.put("/tenants/current/settings", settings);
  },

  /**
   * Update settings for a specific tenant (global admin)
   */
  updateSettings: (id, settings) => {
    return apiClient.put(`/tenants/${id}/settings`, settings);
  },
};

export default { usersApi, tenantsApi };
